"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STORED_AUTH_USER = 'STORED_AUTH_USER';
//# sourceMappingURL=type.js.map